'use client';

import React from 'react';

/**
 * Full-page pulsing spinner used during page transitions
 * (account switch, force-home redirect, initial auth check).
 * Matches the login page loading style.
 */
const FullPageSpinner = React.memo(function FullPageSpinner() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-16">
      <div className="relative flex items-center justify-center">
        <div className="absolute w-20 h-20 rounded-full border-4 border-primary/20 animate-ping" style={{ animationDuration: '2s' }} />
        <div className="absolute w-20 h-20 rounded-full border-4 border-transparent border-t-primary animate-spin" style={{ animationDuration: '1s' }} />
        <div className="w-10 h-10 rounded-full bg-primary/10 backdrop-blur-sm" />
      </div>
    </div>
  );
});

FullPageSpinner.displayName = 'FullPageSpinner';
export default FullPageSpinner;
